'use strict';

var Transformer = require('../transformers/googleTagManagerTransformer');

var GoogleTagManager = {};

GoogleTagManager.initialise = function () {
  // GTM uses an array on the window to track events
  window.dataLayer = window.dataLayer || [];
  GoogleTagManager._dataLayer = window.dataLayer;
  return 'googletagmanager';
};

/*
 *  Google Enhanced Ecommerce Methods
 */

GoogleTagManager._push = function (payload) {
  return GoogleTagManager._dataLayer.push(payload);
};

GoogleTagManager.page = function (system, payload) {
  var transformedPayload = Transformer.pageLoadEvent(system, payload);
  return GoogleTagManager._push(transformedPayload);
};

GoogleTagManager.inline = function (type, payload) {
  if (type !== 'view') return;
  return GoogleTagManager._push(Transformer[type](payload));
};

GoogleTagManager.error = function (payload) {
  var transformedPayload = Transformer.error(payload);
  return GoogleTagManager._push(transformedPayload);
};

// now _action is a higher order function, so
// GoogleTagManager.addToBasket(payload) is the same as
// GoogleTagManager._action('addToBasket')(payload)
GoogleTagManager._action = function (method) {
  return function (payload) {
    return GoogleTagManager._push(Transformer[method](payload));
  };
};

var actions = ['addToBasket', 'removeFromBasket', 'productImpressions', 'productClick', 'productDetails', 'purchase', 'addToBooking'];

for (var index in actions) {
  GoogleTagManager[actions[index]] = GoogleTagManager._action(actions[index]);
}

module.exports = GoogleTagManager;